export class Sections {
  public static readonly AuditLogs: string = 'AuditLogs';
  public static readonly Companies: string = 'Companies';
  public static readonly Company: string = 'Company';
  public static readonly CompanyBanks: string = 'CompanyBanks';
  public static readonly EmailMessages: string = 'EmailMessages';
  public static readonly FinancialTransactions: string = 'FinancialTransactions';
  public static readonly Modules: string = 'Modules';
  public static readonly PaymentActions: string = 'PaymentActions';
  public static readonly PaymentActionsUrl: string = 'PaymentActionsUrl';
  public static readonly PaymentRequests: string = 'PaymentRequests';
  public static readonly PaymentRequestUrl: string = 'PaymentRequestUrl';
  public static readonly PaymentRequestInformation: string = 'PaymentRequestInformation';
  public static readonly DocumentIntelligence: string = "DocumentIntelligence";
  public static readonly Settings: string = 'Settings';
  public static readonly SmsMessages: string = 'SmsMessages';
  public static readonly Users: string = 'Users';
  public static readonly User: string = 'User';
}
